/* -----------------------------------------------------------
 * AnimationReveal.jsx  (只列出改动后的关键部分)
 * ----------------------------------------------------------*/
import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { motion } from "framer-motion";
import useInView from "helpers/useInView";

const StyledDiv = styled.div(({ $compact }) => [
    tw`font-display min-h-screen text-secondary-500 overflow-hidden`,
    $compact ? tw`px-2 sm:px-8 py-8` : tw`p-8`,
]);

/* ❶ 渐入渐出版本 — 不再需要方向 props */
function AnimatedFadeComponent({ offset = 30, children }) {
    const [ref, inView] = useInView({ margin: `-${offset}px 0px -${offset}px 0px` });

    return (
        <div ref={ref}>
            <motion.section
                initial={{ opacity: 0 }}
                animate={{ opacity: inView ? 1 : 0 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
            >
                {children}
            </motion.section>
        </div>
    );
}

/* ❷ AnimationReveal 改用 AnimatedFadeComponent */
function AnimationReveal({ disabled, children }) {
    if (disabled) return <>{children}</>;
    if (!Array.isArray(children)) children = [children];

    const childrenWithAnimation = children.map((child, i) => (
        <AnimatedFadeComponent key={i}>{child}</AnimatedFadeComponent>
    ));
    return <>{childrenWithAnimation}</>;
}

/* ❸ 其余保持不变 */
export default ({ compact = false, ...props }) => (
    <StyledDiv className="App" $compact={compact}>
        <AnimationReveal {...props} />
    </StyledDiv>
);
